export default {
  unsaved: {
    title: 'Salvezi modificările?',
    description: 'Ai făcut modificări la acest pas care nu au fost încă salvate.',
    discard: 'Renunță',
    save_and_continue: 'Salvează și continuă',
  },
  title: 'Configurați restaurantul dvs.',
  nav: {
    completed: 'Finalizat',
    locked: 'Gestionat de furnizorul dvs.',
    aria_label: 'Pași de lansare',
    step_label: 'Pasul {{number}}',
    section_label: 'Lansare',
    back_to_home: 'Înapoi la pagina principală',
  },
  owner_invite: {
    hint: 'Preferați ca proprietarul restaurantului să finalizeze configurarea singur? Invitați-l și va continua de unde ați rămas.',
    sent: 'Invitație trimisă către {{name}} ({{email}}) pe {{date}}.',
  },
  footer: {
    step_of: 'Pasul {{current}} din {{total}}',
  },
  buttons: {
    next_task: 'Sarcina următoare',
    cancel: 'Anulează',
    back: 'Înapoi',
    next: 'Continuați',
    save: 'Salvați',
    exit: 'Ieșiți din configurare',
    retry: 'Încercați din nou',
  },
  errors: {
    progress_load_failed: 'Nu am putut încărca progresul configurării pentru acest restaurant.',
    linked_company_unavailable:
      'Acest link duce către un restaurant pe care nu îl poți deschide, așa că ai rămas pe cel curent.',
  },
  placeholder: {
    title: 'Acest pas va fi disponibil în curând',
    description: 'Shell-ul expertului și urmărirea progresului sunt gata. Această fază va fi construită ulterior.',
  },
  new_restaurant: {
    title: 'Restaurant nou',
    menu: {
      title: 'Meniu',
      description: 'Un demo sare onboarding-ul, deci importați meniul acum.',
    },
    demo: {
      title: 'Demo nou',
      description: 'Un restaurant demo pentru testare — sare majoritatea onboarding-ului.',
      label: 'Creați demo',
    },
    description: 'Spuneți-ne unde se află acest restaurant. Îl vom căuta pe Google Maps.',
  },
  location: {
    edit_description: 'Actualizați locația acestui restaurant.',
    cta: 'Creați restaurantul',
    section: {
      address: 'Informații de bază',
      group: 'Brand',
      group_description: 'Această locație face parte dintr-un brand pe care îl ai deja?',
    },
    form: {
      name: {
        label: 'Numele restaurantului',
        placeholder: 'Căutați restaurantul dvs.…',
        help: 'Începeți să tastați pentru a căuta restaurantul pe Google Maps.',
      },
      address: {
        label: 'Adresă stradală',
        placeholder: 'Strada și numărul',
      },
      city: {
        label: 'Oraș',
      },
      zip_code: {
        label: 'Cod poștal',
      },
      country: {
        label: 'Țară',
      },
      region: {
        label: 'Stat / Regiune',
        placeholder: 'Selectați un stat sau o regiune',
      },
    },
    group: {
      aria_label: 'Opțiuni brand',
      deferred_hint: 'Vei alege numele brandului și adresa web la ultimul pas.',
      existing: {
        title: 'Adaugă la un brand existent',
        description: 'O altă locație sub un brand pe care îl operezi deja.',
        select_label: 'Brand',
        select_placeholder: 'Selectează un brand',
      },
      new: {
        title: 'Creează un brand nou',
        description: 'Un singur restaurant, sau prima locație a unui brand nou.',
      },
    },
    toasts: {
      update_failed: 'Nu s-a putut salva locația. Vă rugăm încercați din nou.',
      created: 'Restaurant creat',
      create_failed: 'Nu s-a putut crea restaurantul. Vă rugăm încercați din nou.',
    },
  },
  domain: {
    url_setup: {
      title: 'Adresă comandă online',
      description: 'Unde vor plasa clienții comenzile.',
    },
    modes: {
      foodamigos: {
        host_fallback: 'domeniul tău de comandă online',
        title: 'Folosește domeniul nostru generic',
      },
      custom: {
        title: 'Conectează propriul domeniu',
        description: 'Folosește un domeniu deținut deja de restaurant.',
      },
    },
    toasts: {
      save_failed: 'Adresa de comandă online nu a putut fi salvată. Te rugăm să încerci din nou.',
    },
  },
  go_live: {
    subtitle: 'Verifică că fiecare pas este finalizat, apoi activează comenzile live.',
    slug: {
      // Answers the open question in round-2 §8: PartialUpdateFranchiseRequest
      // carries no go-live guard on the slug, so it can be changed at any time —
      // but there is no redirect table, so the previous address stops resolving.
      // Saying so removes the hesitation without overpromising.
      help: 'Doar litere, cifre și cratime. Poți schimba mai târziu, dar adresa veche va înceta să funcționeze.',
      title: 'Adresă comandă online',
      description: 'Aici vor comanda clienții tăi. Îl poți schimba ulterior.',
      label: 'Personalizează cu numele restaurantului',
      placeholder: 'bella-italia',
      preview: 'Pagina ta de comandă:',
      save: 'Salvează URL',
      saved: 'Adresa de comandă online a fost salvată',
      save_failed: 'URL-ul nu a putut fi salvat. Încearcă din nou.',
      status: {
        checking: 'Se verifică disponibilitatea…',
        available: 'Disponibil',
        taken: 'Acest URL este deja folosit',
        invalid: 'Folosiți doar litere, cifre, cratime și underscore-uri',
        error: 'Nu s-a putut verifica disponibilitatea — vă rugăm încercați din nou',
      },
    },
    domain: {
      title: 'Domeniu personalizat (opțional)',
      description: 'Folosește propriul domeniu în locul adresei oferite de FoodAmigos.',
      add: '+ Adaugă un domeniu personalizat',
      hide: 'Ascunde domeniul personalizat',
      label: 'Domeniul tău',
      placeholder: 'shop.restaurantulmeu.ro',
      save: 'Salvați',
      show_records: 'Afișează înregistrările DNS',
      hint: 'Doar pentru comenzi — site-ul dumneavoastră are nevoie de alt domeniu. De exemplu order.restaurantulmeu.ro pentru magazin și restaurantulmeu.ro pentru site.',
      records_after_save:
        'După ce salvați domeniul, vă arătăm exact înregistrările de adăugat la furnizorul DNS — un domeniu principal (restaurantulmeu.ro) și un subdomeniu (order.restaurantulmeu.ro) au nevoie de înregistrări diferite.',
      saved: 'Domeniu personalizat salvat',
      save_failed: 'Domeniul nu a putut fi salvat. Încearcă din nou.',
      unconfirmed: {
        title: 'Lansarea nu așteaptă acest domeniu',
        description:
          'Până când înregistrările lui sunt confirmate, pagina de comandă rămâne pe adresa standard, iar restaurantul poate fi lansat acolo. După confirmare — poate dura până la 48 de ore —, domeniul va afișa automat pagina de comandă.',
      },
    },
    locations: {
      title: 'Confirmă locațiile',
      description:
        'Fiecare locație din brandul tău primește propria adresă de comandă. Confirmă sau editează-le mai jos.',
      save: 'Salvează locațiile',
      saved: 'URL-urile locațiilor salvate',
      save_failed: 'Unul sau mai multe URL-uri de locație nu au putut fi salvate. Încearcă din nou.',
    },
    preflight: {
      title: 'Înainte de lansare',
      description: 'Finalizează acestea pentru a activa comenzile live.',
      url_setup: 'Adresă de comandă configurată',
      online_payment: {
        your_provider: 'furnizorul tău',
        payments_live: '{{title}} · finalizat',
        online_payments_off: '{{title}} · nu acceptă plăți online',
        waiting_for_provider: '{{title}} · se așteaptă {{provider}}',
        hosted_not_finished: '{{title}} · finalizează cu {{provider}}',
        action_needed: '{{title}} · necesită acțiune',
        waiting_for_partner: '{{title}} · se așteaptă partenerul tău',
        not_set_up: '{{title}} · neconfigurat',
        business_details_missing: '{{title}} · adaugă datele firmei pentru plăți',
      },
    },
    failed_checks: {
      title: 'Câteva lucruri mai necesită atenție',
      items: {
        name: 'Numele restaurantului',
        logo_url: 'Logo',
        pictures: 'Fotografii galerie',
        menu_uploaded: 'Meniu',
        opening_hours: 'Program de funcționare',
        address: 'Adresă',
        storefront: 'Adresă comandă',
        payments_configured: 'Plăți',
        stripe_billing: 'Facturare',
        test_orders: 'Comandă de test',
        google_business: 'Profil Google Business',
        master_promo_code: 'Cod promoțional de bun venit',
        flyers_ordered: 'Flyere comandate',
        identity: 'Tip restaurant & bucătării',
        billing_payment_method: 'Metodă de plată',
        billing_license: 'Licență',
        business_name: 'Numele firmei / al restaurantului',
        payment_method: 'Plată cash sau online',
        stripe_processing_fee: 'Comision de procesare partener',
      },
      force: 'Lansează oricum',
      blocker: '(obligatoriu)',
      link: 'Deschide Partner Billing',
    },
    error: 'Comenzile live nu au putut fi activate. Încearcă din nou.',
    gate_hint: 'Finalizează lista de verificare de mai sus pentru a activa Lansarea.',
    business_name: {
      label: 'Numele firmei / al restaurantului',
      help: 'Apare în termenii de utilizare și în politica de confidențialitate. Folosește numele sub care funcționează afacerea ta.',
      save: 'Salvați',
      save_failed: 'Numele firmei nu a putut fi salvat. Încearcă din nou.',
      hint: 'Salvează mai întâi numele firmei / al restaurantului.',
    },
    cash_only: {
      message:
        'Plățile online sunt dezactivate — clienții pot plăti doar numerar la ridicare sau la livrare până când un procesator este conectat și verificat.',
    },
    payment_blocked: {
      title: 'Activează plățile cash sau configurează plățile online pentru a lansa.',
      payment_method: 'Clienții au nevoie de o modalitate de plată.',
      turn_on_cash: 'Activează plățile cash',
      ask_partner: 'Cere partenerului tău să activeze plățile cash, sau',
      set_up_online: 'configurează plățile online',
    },
    buttons: {
      go_live: 'Lansare 🚀',
      finish: 'Finalizează configurarea',
    },
    celebration: {
      title: 'Ești live!',
      title_named: '{{name}} este live!',
      subtitle: 'Restaurantul tău acceptă acum comenzi live.',
      license: '{{plan}} · activ',
      license_trial: '{{plan}} · gratuit până la {{date}}',
      finish: 'Finalizează configurarea',
    },
    service_fee: {
      title: 'Taxă de serviciu',
      headline: 'Câștigă venituri suplimentare fără a taxa restaurantele tale',
      subtitle:
        'Adaugă o mică taxă de serviciu pe care clienții o plătesc la finalizarea comenzii. Tu păstrezi jumătate. Rămâne dezactivată până o activezi.',
      subtitle_share:
        'Adaugă o mică taxă de serviciu pe care clienții o plătesc la finalizarea comenzii. Tu păstrezi {{share}}%. Rămâne dezactivată până o activezi.',
      tiles: {
        guest: {
          title: 'Plătită de client',
          description: 'Afișată la finalizarea comenzii, ca în aplicațiile de livrare.',
        },
        share: {
          title: 'Jumătate ajunge la tine',
          title_share: '{{share}}% ajunge la tine',
          description: 'Împărțire {{share}}/{{rest}} cu FoodAmigos.',
        },
        choice: {
          title: 'Alegerea ta',
          description: 'Dezactivată implicit. O poți schimba oricând.',
        },
      },
      preview: {
        title: 'Ce ar vedea clienții la finalizarea comenzii',
        subtotal: 'Subtotal comandă',
        fee: 'Taxă de serviciu',
        fee_terms: '({{percentage}}%, max. {{max}})',
        guest_pays: 'Clientul plătește',
        split_partner: '<strong>Tu {{amount}}</strong> per comandă',
        split_provider: 'FoodAmigos {{amount}}',
        unchanged: 'Valoarea comenzii restaurantului rămâne neschimbată.',
      },
      earnings: {
        title: 'Ce ai putea câștiga de la acest restaurant',
        orders: 'Comenzi online pe lună',
        average_order: 'Comandă medie',
        per_month: 'pe lună pentru tine',
        collected: '{{amount}} încasați de la clienți pe lună. Partea ta: {{share}}%. Doar estimare.',
        effective_rate: 'Rata efectivă a taxei pentru toate comenzile: {{rate}}',
      },
      choice: {
        question: 'Adaugi o taxă de serviciu pentru acest restaurant?',
        enabled: {
          title: 'Adaugă o taxă de serviciu',
          recommended: 'Recomandat: {{percentage}}%, max. {{max}}',
          description: 'Clienții plătesc o mică taxă. Tu câștigi o parte.',
        },
        skipped: {
          title: 'Fără taxă de serviciu',
          description: 'Clienții plătesc doar prețurile din meniu.',
        },
      },
      footer: {
        enabled:
          'Clienții plătesc {{percentage}}%, max. {{max}} per comandă. Poți schimba oricând în <settings>Setări comenzi → Taxă de serviciu</settings>.',
        skipped:
          'Momentan fără taxă de serviciu. Poți schimba oricând în <settings>Setări comenzi → Taxă de serviciu</settings>.',
      },
      enabled:
        'Taxa de serviciu este acum activă la acest restaurant, la {{percentage}}%, plafonată la {{max}} per comandă. Se aplică tuturor comenzilor noi de acum încolo. O puteți modifica oricând în <settings>Setări comenzi → Taxă de serviciu</settings>.',
      enabled_partner_default:
        'Taxa de serviciu este acum activă la acest restaurant. Se aplică valoarea implicită a partenerului dvs.: {{percentage}}%, plafonată la {{max}} per comandă. Se aplică tuturor comenzilor noi de acum încolo. O puteți modifica oricând în <settings>Setări comenzi → Taxă de serviciu</settings>.',
      buttons: {
        enable: 'Activează taxa de serviciu',
        continue_without: 'Continuă fără taxă',
      },
      skipped:
        'Clienții acestui restaurant nu plătesc taxă de serviciu. O puteți activa oricând în <settings>Setări comenzi → Taxă de serviciu</settings>.',
      toasts: {
        save_failed: 'Nu s-a putut salva opțiunea privind taxa de serviciu. Te rugăm să încerci din nou.',
      },
    },
  },
  toasts: {
    save_failed: 'Modificările nu au putut fi salvate. Încearcă din nou.',
    saved: 'Salvat',
  },
  optional: 'Opțional',
  identity: {
    min_cuisine_hint: 'Selectează cel puțin o bucătărie pentru a continua.',
    sections: {
      restaurant_type: {
        title: 'Tip restaurant',
        description: 'Ce fel de unitate este aceasta?',
      },
      cuisine: {
        title: 'Tipuri de bucătărie',
        description: 'Alege cel puțin una.',
      },
    },
  },
  menu: {
    modes: {
      recommended: 'Recomandat',
      import: {
        title: 'Importă dintr-o platformă',
        description: 'Preia meniul din Wolt, Lieferando, Deliveroo și altele.',
      },
      manual: {
        title: 'Construiește meniul de la zero',
        description: 'Creează categorii și articole manual în editorul de meniu.',
      },
    },
    import: {
      title: 'Importă dintr-o platformă existentă',
      in_progress: {
        title: 'Se importă meniul…',
        description: 'De obicei durează sub două minute. Vom finaliza acest pas imediat ce se termină.',
      },
      failed: {
        title: 'Importul nu s-a finalizat',
        description: 'Importul meniului nu a putut fi finalizat. Verifică detaliile și încearcă din nou.',
      },
      blocked: {
        until: 'În pauză până la {{time}}',
        release: 'Eliberează linkul',
        released: 'Link eliberat. Poți porni din nou importul.',
        release_failed: 'Linkul nu a putut fi eliberat. Încearcă din nou în câteva momente.',
      },
      stalled: {
        title: 'Se importă în continuare…',
        description:
          'Importul durează mai mult decât de obicei. Poate rulează încă în fundal — verifică din nou într-un moment. Pornirea unui nou import acum ar putea dubla meniul.',
      },
    },
    manual: {
      title: 'Construiește meniul de la zero',
      description:
        'Editorul de meniu se deschide cu un meniu gol. Acest pas este complet odată ce există cel puțin o categorie și un articol.',
      open_editor: 'Deschide editorul de meniu',
      waiting: {
        title: 'Se așteaptă primul articol din meniu',
        description: 'Odată ce adaugi un articol în editorul de meniu, acest pas poate fi finalizat.',
      },
      found: {
        title: 'Articole de meniu detectate',
        description: 'Excelent — poți continua la pasul următor.',
      },
    },
    complete: {
      title: 'Meniu gata',
      description: 'Meniul este configurat. Îl poți revizui oricând din editorul de meniu.',
    },
    buttons: {
      start_import: 'Începe importul',
      importing: 'Se importă…',
      retry: 'Reîncearcă importul',
      check_again: 'Verifică din nou',
      continue: 'Continuați',
      skip: 'Sari deocamdată',
    },
  },
  phases: {
    // Stands in for the restaurant name in phase descriptions before it is known.
    fallback_name: 'acest restaurant',
    location: {
      title: 'Locație',
      description: 'Unde este restaurantul și cărui brand îi aparține?',
    },
    identity: {
      title: 'Identitate',
      description: 'Tip restaurant și bucătării.',
    },
    brand: {
      title: 'Brand',
      description: 'Logo, culori și galerie.',
    },
    operations: {
      title: 'Detalii locație',
      description:
        'Configurează cum primește {{name}} comenzi. Acesta este minimul necesar înainte de a putea primi orice comandă.',
    },
    menu: {
      title: 'Meniu',
      description:
        'Adaugă meniul lui {{name}} pe platformă. Importă-l dintr-o platformă existentă în sub două minute sau construiește-l de la zero.',
    },
    domain: {
      title: 'Domeniu',
      description: 'Adresa web pe care clienții o folosesc pentru a comanda de la acest restaurant.',
    },
    go_live: {
      title: 'Lansare',
      description: 'Activează comenzile live.',
    },
    payouts: {
      title: 'Plată online',
      description: 'Cum acceptă acest restaurant plata online.',
    },
    service_fee: {
      title: 'Taxă de serviciu',
      description:
        'Dacă oaspeții plătesc o taxă de serviciu la finalizarea comenzii. O puteți modifica ulterior în Setări comandă → Taxe.',
    },
    bank_account: {
      title: 'Cont bancar',
      description:
        'Unde se trimit plățile. Nu este necesar pentru lansare: plățile rămân în sold până la adăugarea unui cont.',
    },
  },
  business_details: {
    locked: 'Aceste detalii sunt verificate cu furnizorul dvs. de plăți. Pentru a le modifica, contactați FoodAmigos.',
    section: {
      title: 'Detalii afacere',
    },
    fields: {
      business_type: {
        label: 'Tip de afacere',
        options: {
          company: 'Companie (SRL, GmbH, UG, Ltd, Inc — o entitate juridică înregistrată)',
          individual: 'Persoană fizică (dvs. personal dețineți și conduceți afacerea)',
        },
      },
      owner_first_name: { label: 'Prenumele proprietarului' },
      owner_last_name: { label: 'Numele proprietarului' },
      legal_name: {
        label: 'Denumirea legală a afacerii',
        individual:
          'Conduceți afacerea personal, așadar numele proprietarului este folosit ca denumire legală a afacerii.',
      },
      legal_address: { label: 'Adresă înregistrată' },
      legal_city: { label: 'Oraș' },
      legal_state: { label: 'Stat sau provincie' },
      legal_zip_code: { label: 'Cod poștal' },
      legal_country: { label: 'Țară' },
      tax_id: {
        generic: 'Cod fiscal sau număr de înregistrare',
        personal: 'Sunt afișate doar ultimele patru cifre. Lăsați-l așa cum este pentru a păstra numărul neschimbat.',
        hint: 'De exemplu {{example}}.',
        invalid:
          'Acest lucru nu corespunde formatului obișnuit pentru această țară și tip de afacere, de exemplu {{example}}.',
      },
      is_vat_registered: { label: 'Această afacere este înregistrată în scopuri de TVA' },
      vat_id: {
        label: 'Număr de TVA',
        help: 'Începe cu {{country}}, urmat de 8 până la 12 litere sau cifre.',
        invalid: 'Numărul de TVA trebuie să înceapă cu {{country}}, urmat de 8 până la 12 litere sau cifre.',
        help_unprefixed: 'Numărul dvs. de TVA sau de înregistrare fiscală, așa cum a fost emis.',
        invalid_unprefixed: 'Acesta nu pare un număr de TVA: folosiți între 5 și 25 de litere sau cifre.',
      },
    },
    toasts: {
      save_failed: 'Nu s-au putut salva detaliile afacerii. Vă rugăm să încercați din nou.',
    },
  },
  brand: {
    fields: {
      short_name: {
        label: 'Nume scurt',
        placeholder: 'ex. Amigo Pizza',
        tooltip: 'Un nume de afișare mai scurt folosit în vitrină și pe chitanțe.',
      },
      primary_color: {
        label: 'Culoare principală',
        invalid: 'Introdu o culoare hex validă, ex. #1A73E8.',
      },
    },
    sections: {
      short_name: 'Nume',
      short_name_hint: 'Folosit în vitrină, pe chitanțe și notificări.',
      logo_and_colour: 'Logo & culoarea principală a brandului',
      logo: 'Încarcă logo',
      logo_hint: 'Dacă lăsați acest câmp gol, va fi folosit logo-ul brandului dvs.',
      gallery: 'Fotografii galerie',
      gallery_hint: 'Adaugă până la {{max}} fotografii ale restaurantului tău. Trage pentru a reordona.',
      gallery_count: '{{count}} din {{max}} adăugate',
    },
    toasts: {
      image_uploaded: 'Imagine încărcată',
      image_upload_failed: 'Imaginea nu a putut fi încărcată. {{error}}',
      save_failed: 'Detaliile brandului nu au putut fi salvate. Vă rugăm să încercați din nou.',
    },
  },
  operations: {
    contact: {
      title: 'Contact',
      description: 'Utilizat pentru notificări de comenzi și comunicări cu clienții.',
      phone: {
        label: 'Numărul de telefon al restaurantului',
        placeholder: '+49 30 1234567',
        invalid: 'Introduceți un număr de telefon internațional complet, ex. +49 30 1234567',
      },
      email: { label: 'Emailul restaurantului', placeholder: 'orders@restaurant.com' },
    },
    methods: {
      title: 'Metode de comandă',
      description: 'Cum pot comanda clienții și cât durează fiecare metodă.',
      pickup: {
        label: 'Ridicare',
        prep_time: { label: 'Timp mediu de preparare (min)' },
      },
      delivery: {
        label: 'Livrare',
        delivery_time: { label: 'Timp mediu de livrare (min)' },
        advanced_zones: 'Configurare avansată zone',
      },
    },
    timing: {
      title: 'Programare comenzi',
      description: 'Când pot plasa comenzi clienții — acum, mai târziu sau în avans.',
      at_least_one: 'Activați comanda imediată sau programată (cel puțin una este obligatorie).',
      asap: { label: 'Acceptă comenzi imediate' },
      scheduled: { label: 'Acceptă comenzi programate' },
      reminders: { label: 'Trimite un memento automat înainte de scadența unei comenzi programate' },
      pre_order: {
        label: 'Permite pre-comenzi pentru zile viitoare',
        days: { label: 'Cu câte zile înainte (0-31)' },
      },
    },
    tax: {
      title: 'TVA',
      description:
        'Cota aplicată produselor acestui restaurant. Începe de la cota pentru regiune — modific-o doar dacă acest restaurant percepe altă cotă.',
      rate: { label: 'Cotă TVA', placeholder: 'de ex. 7' },
      dedicated: { label: 'TVA diferă în funcție de produs' },
    },
    hours: {
      title: 'Program de funcționare',
      description: 'Zilele și orele în care restaurantul acceptă comenzi.',
      same_every_day: 'Aceleași ore în fiecare zi',
      split_shifts: {
        title: 'Acest restaurant are program de deschidere divizat',
        description:
          'Unele zile au mai multe intervale de deschidere (de exemplu prânz și cină). Editorul simplu afișează un singur interval pe zi, deci păstrăm orele existente — editați schimburile divizate în Setări comenzi → Program de deschidere.',
      },
    },
    toasts: {
      save_failed: 'Setările operaționale nu au putut fi salvate. Vă rugăm să încercați din nou.',
    },
  },
  online_payment: {
    question: 'Dorești să accepți plăți online pentru acest restaurant?',
    yes: 'Da',
    not_now: 'Nu acum',
    declined: 'Clienții vor plăti la ridicare sau livrare. Poți activa plățile online oricând din Setări.',
    providers: {
      stripe: 'Stripe',
      adyen: 'Adyen',
    },
    waiting_for_partner: {
      staff: {
        title: 'Plățile nu sunt încă configurate pentru contul tău de partener',
        description:
          'Un administrator al contului tău de partener trebuie să aleagă cine procesează plățile înainte ca acest restaurant să poată accepta plăți online. Între timp poți continua cu celelalte etape.',
      },
    },
    continue_to_go_live: 'Continuă spre Lansare',
    platform_line: 'Plățile pentru acest restaurant se procesează prin FoodAmigos payments.',
    only_connection: 'Plățile se procesează prin {{name}} (singurul tău furnizor conectat).',
    partner_issue: {
      title: 'Partenerul dvs. {{partner}} trebuie să finalizeze configurarea furnizorului de plăți',
      description:
        'Furnizorul lor de plăți nu poate înrola încă restaurante. Le-am transmis acest lucru — datele dvs. sunt salvate, așa că reveniți după ce ne confirmă că s-a rezolvat.',
      retry_hint: 'După remediere, continuați din nou către furnizor și vom reîncerca.',
      open_settings: 'Deschideți setările gateway-ului de plată',
    },
    connect_another: 'Conectează alt furnizor',
    checking: 'Se verifică cu {{provider}}…',
    checking_generic: 'Se verifică cu furnizorul de plăți…',
    retry: 'Încercați din nou',
    not_set_up: {
      title: 'Niciun furnizor de plăți conectat încă',
      description:
        'Partenerul tău conectează un furnizor de plăți la acest restaurant. După ce o face, poți finaliza configurarea aici.',
    },
    choice: {
      title: 'Ce furnizor conectat ar trebui să folosească acest restaurant?',
      primary: 'Principal',
      confirm: 'Folosește acest furnizor',
      cancel: 'Anulează',
    },
    using: 'Se folosește {{name}}',
    change: 'Schimbă',
    payout_details: {
      title: 'Datele firmei pentru plăți',
      description: 'Necesare furnizorului de plăți pentru a-ți verifica afacerea și a trimite plățile.',
      business_type: {
        company: {
          title: 'Companie',
          description: 'GmbH, SRL, Ltd, Inc — o persoană juridică înregistrată',
        },
        individual: {
          title: 'Persoană fizică',
          description: 'Deții și conduci personal afacerea',
        },
      },
      registered_address: 'Adresă înregistrată',
      legal_address: 'Adresă stradală',
      legal_state: 'Stat / regiune',
      vat_id: 'Cod TVA',
      optional: '(opțional)',
      fill_first: 'Completează mai întâi datele firmei pentru plăți de mai sus.',
    },
    hand_off: {
      title: 'Următorul pas: finalizează configurarea cu {{provider}}',
      description:
        '{{provider}} va cere actul de identitate al proprietarului în propriul formular, folosind datele firmei pentru plăți de mai sus. Aproximativ 10 minute. Contul bancar urmează după lansare.',
      cta: 'Continuă către {{provider}}',
      transition: 'Te redirecționăm către {{provider}}…',
      error: 'Nu am putut deschide formularul {{provider}}. Te rugăm să încerci din nou.',
    },
    states: {
      verified: 'Plățile sunt active.',
      submitted: {
        title: 'Detalii trimise către {{provider}}',
        description:
          'Verificarea durează de obicei 1–2 zile lucrătoare. Îl vom anunța pe proprietarul restaurantului prin e-mail când este gata.',
        description_email:
          'Verificarea durează de obicei 1–2 zile lucrătoare. Te vom anunța prin e-mail la {{email}} când este gata.',
        review: {
          business_type: 'Tip de afacere',
          legal_name: 'Denumire legală',
          address: 'Adresă înregistrată',
          types: {
            company: 'Companie',
            individual: 'Persoană fizică',
          },
        },
      },
      incomplete: {
        title: 'Nu ai finalizat cu {{provider}}',
        description: 'Detaliile tale sunt salvate — linkul este valabil 2 zile.',
        expired: 'Detaliile tale sunt salvate, dar linkul a expirat.',
        cta: 'Continuă cu {{provider}}',
        new_link: 'Obține un link nou și continuă',
        check_details: 'Verifică mai întâi detaliile mele',
      },
      action_needed: {
        title: '{{provider}} mai are nevoie de un lucru',
        description:
          '{{provider}} nu a putut verifica unul dintre detaliile furnizate. Deschide din nou formularul lor pentru a-l corecta.',
        cta: 'Deschide din nou formularul {{provider}}',
      },
    },
    connected: {
      title: 'Plățile trec prin {{name}}',
      description: 'Acest restaurant este asociat contului {{name}} — nu mai este nimic de configurat aici.',
      failed: 'Nu am putut conecta încă acest restaurant la {{name}}',
    },
    errors: {
      generic: 'Ceva nu a funcționat corect. Te rugăm să încerci din nou.',
      load_failed: 'Nu am putut încărca configurarea plăților acestui restaurant.',
    },
  },
  bank_account: {
    section: {
      title: 'Cont bancar pentru plăți',
      description: 'Plățile se trimit în {{currency}}, moneda în care acest restaurant încasează plăți.',
    },
    done: 'Înapoi la panou',
    load_failed: 'Nu am putut încărca contul bancar al acestui restaurant.',
    retry: 'Încercați din nou',
    no_permission: 'Doar proprietarul restaurantului sau partenerul poate introduce contul bancar.',
    confirm_with_provider: 'Confirmă cu Adyen',
    toasts: {
      save_failed: 'Nu am putut salva contul bancar. Verifică datele.',
    },
  },
  payouts: {
    finish_setup: 'Finalizează configurarea',
  },
};
